(function () {
  'use strict';
  
  console.log('🚀 Custom Header Script Loading...');

  /* -------------------
     CART COUNT SYNC
  ------------------- */
  function getNativeCount() {
    return document.querySelector('.cart-icon-bubble-count, .header__cart-count, [data-cart-count]');
  }

  function syncCartCount() {
    const cartCountEl = document.getElementById('cg-cart-count');
    const native = getNativeCount();
    const overlayCartCount = document.getElementById('cg-overlay-cart-count');
    
    if (cartCountEl || overlayCartCount) {
      if (native) {
        const countText = native.textContent.trim();
        if (cartCountEl) cartCountEl.textContent = countText;
        if (overlayCartCount) {
          overlayCartCount.innerHTML = countText > 0 
            ? `<span aria-hidden="true">${countText}</span><span class="visually-hidden">${countText} items</span>`
            : '';
        }
      } else {
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            const count = cart.item_count || 0;
            if (cartCountEl) cartCountEl.textContent = count;
            if (overlayCartCount) {
              overlayCartCount.innerHTML = count > 0 
                ? `<span aria-hidden="true">${count}</span><span class="visually-hidden">${count} items</span>`
                : '';
            }
          })
          .catch(() => {});
      }
    }
  }

  /* -------------------
       MENU OVERLAY
  ------------------- */
  function openMenu() {
    const menuOverlay = document.getElementById('cg-menu-overlay');
    const menuToggle = document.getElementById('cg-menu-toggle');
    
    if (!menuOverlay) return;
    
    console.log('📂 Opening menu overlay');
    menuOverlay.setAttribute('aria-hidden', 'false');
    menuOverlay.classList.add('active');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    const menuOverlay = document.getElementById('cg-menu-overlay');
    const menuToggle = document.getElementById('cg-menu-toggle');
    
    if (!menuOverlay) return;
    
    console.log('📂 Closing menu overlay');
    menuOverlay.setAttribute('aria-hidden', 'true');
    menuOverlay.classList.remove('active');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
  }

  /* -------------------
    CART COUNT OBSERVER
  ------------------- */
  function observeCart() {
    const native = getNativeCount();

    if (native && window.MutationObserver) {
      const mo = new MutationObserver(syncCartCount);
      mo.observe(native, { childList: true, subtree: true, characterData: true });
    }
  }

  /* -------------------
    CART OPENER
  ------------------- */
  function triggerCartOpen() {
    console.log('🛒 Opening cart drawer...');
    
    // Close menu first
    closeMenu();
    
    // Wait for menu to close smoothly
    setTimeout(() => {
      const mainCartBtn = document.getElementById('cart-link');
      
      if (mainCartBtn) {
        console.log('✅ Found #cart-link, clicking it...');
        
        // Simulate a real click
        const clickEvent = new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true,
          clientX: 0,
          clientY: 0
        });
        
        mainCartBtn.dispatchEvent(clickEvent);
        console.log('✅ Click dispatched');
      } else {
        console.log('❌ #cart-link not found');
      }
    }, 250);
  }

  /* -------------------
    SETUP EVENT LISTENERS
  ------------------- */
  function setupEventListeners() {
    console.log('⚡ Setting up event listeners...');
    
    // Menu toggle button
    const menuToggle = document.getElementById('cg-menu-toggle');
    if (menuToggle) {
      menuToggle.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('🖱️ Menu toggle clicked');
        openMenu();
      });
    }

    // Close buttons
    document.querySelectorAll('.cg-overlay-close, [data-close="cg-menu-overlay"]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('🖱️ Close button clicked');
        closeMenu();
      });
    });

    // Click outside to close
    const menuOverlay = document.getElementById('cg-menu-overlay');
    if (menuOverlay) {
      menuOverlay.addEventListener('click', (e) => {
        if (e.target === menuOverlay) {
          console.log('🖱️ Clicked outside overlay');
          closeMenu();
        }
      });
    }

    // Overlay cart button - using event delegation
    if (menuOverlay) {
      menuOverlay.addEventListener('click', (e) => {
        const cartBtn = e.target.closest('#cg-overlay-cart-btn');
        if (cartBtn) {
          e.preventDefault();
          e.stopPropagation();
          console.log('🛒 Overlay cart button clicked');
          triggerCartOpen();
        }
      }, true);
    }
  }

  /* -------------------
       SMOOTH HEADER ANIMATION
  ------------------- */
  function initSmoothHeader() {
    const header = document.querySelector('.cg-header-inner');
    if (!header) return;

    let lastScrollTop = 0;
    let ticking = false;

    function onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const direction = scrollTop > lastScrollTop ? 'down' : 'up';

      if (direction === 'down') {
        header.classList.add('hide-down');
        header.classList.remove('show-up');
      } else {
        header.classList.remove('hide-down');
        header.classList.add('show-up');
      }

      if (scrollTop > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; 
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    });
  }
  /* -------------------
       INIT
  ------------------- */
  function init() {
    
    syncCartCount();
    observeCart();
    setupEventListeners();
    initSmoothHeader();
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section reloads
  ['shopify:section:load', 'shopify:section:select', 'shopify:section:reorder'].forEach(evt => {
    document.addEventListener(evt, () => {
      console.log('🔄 Section reloaded, re-initializing...');
      setTimeout(init, 100);
    });
  });

  console.log('✅ Custom Header Script Loaded Successfully!');

})();